import { CommonAPIService } from "src/servicehandlers/CommonHandler";

export class AboutYouAPIService {
  constructor() {
    this.CommonAPIService = new CommonAPIService();
  }

  createOrUpdateStudent(params, router) {
    const url = "/api/aboutYou/student";
    return this.CommonAPIService.postCall(url, params, router);
  }

  getStudentByUserId(userId, router) {
    const url = `/api/aboutYou/student/${userId}`;
    return this.CommonAPIService.getCall(url, "", router);
  }

  createOrUpdateInstructor(params, router) {
    const url = "/api/aboutYou/instructor";
    return this.CommonAPIService.postCall(url, params, router);
  }

  createOrUpdateDispatcher(params, router) {
    const url = "/api/aboutYou/dispatcher";
    return this.CommonAPIService.postCall(url, params, router);
  }

  createOrUpdateAdmin(params, router) {
    const url = "/api/aboutYou/admin";
    return this.CommonAPIService.postCall(url, params, router);
  }

  createOrUpdateOwner(params, router) {
    const url = "/api/aboutYou/owner";
    return this.CommonAPIService.postCall(url, params, router);
  }

  createOrUpdateLender(params, router) {
    const url = "/api/aboutYou/lender";
    return this.CommonAPIService.postCall(url, params, router);
  }

  getLenderById(id, router) {
    const url = `/api/aboutYou/lender/${id}`;
    return this.CommonAPIService.getCall(url, "", router);
  }

  getRelationshipsList(router) {
    const url = "/api/aboutYou/relationshipsList";
    return this.CommonAPIService.getCall(url, "", router);
  }

  getEducationLevelsList(router) {
    const url = "/api/aboutYou/educationLevelsList";
    return this.CommonAPIService.getCall(url, "", router);
  }

  getFullOrPartTimeList(router) {
    const url = "/api/aboutYou/fullOrPartTimeList";
    return this.CommonAPIService.getCall(url, "", router);
  }

  getLearningEnvironmentsList(router) {
    const url = "/api/aboutYou/learningEnvironmentsList";
    return this.CommonAPIService.getCall(url, "", router);
  }

  getRatingsList(router) {
    const url = "/api/aboutYou/ratingsList";
    return this.CommonAPIService.getCall(url, "", router);
  }

  getMedicalCertificatesList(router) {
    const url = "/api/aboutYou/medicalCertificatesList";
    return this.CommonAPIService.getCall(url, "", router);
  }

  getFlightSchoolRolesList(router) {
    const url = "/api/aboutYou/flightSchoolRolesList";
    return this.CommonAPIService.getCall(url, "", router);
  }

  getFlightSchoolToolsList(router) {
    const url = "/api/aboutYou/flightSchoolToolsList";
    return this.CommonAPIService.getCall(url, "", router);
  }

  getManagementExperienceList(router) {
    const url = "/api/aboutYou/managementExperienceList";
    return this.CommonAPIService.getCall(url, "", router);
  }

  getFlightSchoolSizeList(router) {
    const url = "/api/aboutYou/flightSchoolSizeList";
    return this.CommonAPIService.getCall(url, "", router);
  }

  getDispatcherOperationsList(router) {
    const url = "/api/aboutYou/dispatcherOperationsList";
    return this.CommonAPIService.getCall(url, "", router);
  }

  getDispatcherCertificatesList(router) {
    const url = "/api/aboutYou/dispatcherCertificatesList";
    return this.CommonAPIService.getCall(url, "", router);
  }

  getDispatcherSkillsList(router) {
    const url = "/api/aboutYou/dispatcherSkillsList";
    return this.CommonAPIService.getCall(url, "", router);
  }

  getDispatcherShiftsList(router) {
    const url = "/api/aboutYou/dispatcherShiftsList";
    return this.CommonAPIService.getCall(url, "", router);
  }

  getAdminResponsibilitiesList(router) {
    const url = "/api/aboutYou/adminResponsibilitiesList";
    return this.CommonAPIService.getCall(url, "", router);
  }

  getBusinessTypesList(router) {
    const url = "/api/aboutYou/businessTypesList";
    return this.CommonAPIService.getCall(url, "", router);
  }

  getLoanProductsList(router) {
    const url = "/api/aboutYou/loanProductsList";
    return this.CommonAPIService.getCall(url, "", router);
  }

  getTargetMarketsList(router) {
    const url = "/api/aboutYou/targetMarketsList";
    return this.CommonAPIService.getCall(url, "", router);
  }

  getLoanTermsList(router) {
    const url = "/api/aboutYou/loanTermsList";
    return this.CommonAPIService.getCall(url, "", router);
  }

  getRequiredDocumentationsList(router) {
    const url = "/api/aboutYou/requiredDocumentationsList";
    return this.CommonAPIService.getCall(url, "", router);
  }

  getGeographicalReachesList(router) {
    const url = "/api/aboutYou/geographicalReachesList";
    return this.CommonAPIService.getCall(url, "", router);
  }

  getRepaymentOptionsList(router) {
    const url = "/api/aboutYou/repaymentOptionsList";
    return this.CommonAPIService.getCall(url, "", router);
  }

  getInternationalStudentEligibilityList(router) {
    const url = "/api/aboutYou/internationalStudentEligibilityList";
    return this.CommonAPIService.getCall(url, "", router);
  }

  getLoanUsageRestrictionsList(router) {
    const url = "/api/aboutYou/loanUsageRestrictionsList";
    return this.CommonAPIService.getCall(url, "", router);
  }

  getStateOptionsList(router) {
    const url = "/api/aboutYou/stateOptionsList";
    return this.CommonAPIService.getCall(url, "", router);
  }
}
export default AboutYouAPIService;
